var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-16 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #24d2dc;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #9c71fb;\n      }\n\n      .cls-3 {\n        fill: #3632a8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m316.11,302.11c3.81,6.58.98,15.07-6,18.09-46.4,20.07-97.5,31.21-151.2,31.21s-104.82-11.14-151.21-31.23c-6.98-3.02-9.8-11.51-5.99-18.09,28.21-48.79,68.21-91.83,116.87-126.4,12.86,9.15,26.31,17.71,40.33,25.62,13.99-7.92,27.44-16.45,40.28-25.62,48.66,34.56,88.7,77.6,116.92,126.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m316.11,49.32c-28.24,48.81-68.25,91.83-116.92,126.37-12.86-9.15-26.31-17.71-40.3-25.62-13.99,7.92-27.44,16.48-40.3,25.62C69.93,141.13,29.92,98.11,1.7,49.3c-3.8-6.58-.98-15.07,6-18.09C54.08,11.12,105.18,0,158.88,0s104.83,11.12,151.23,31.23c6.98,3.02,9.8,11.51,5.99,18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m199.18,175.69c-12.84,9.17-26.29,17.71-40.28,25.62-14.02-7.92-27.47-16.48-40.33-25.62,12.86-9.15,26.31-17.71,40.3-25.62,13.99,7.92,27.44,16.48,40.3,25.62Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55897f93c43c16f58c9a8ce5902fd3da.svg";
export { ForwardRef as ReactComponent };